// frontend/src/index.js
import {
  i18nReady,
} from "./i18n";

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import {
  prewarmCompanySettingsPhotoFromCache,
} from "./utils/companySettingsCache";

import {
  prewarmProfileSettingsAvatarFromCache,
} from "./utils/profileSettingsCache";

import {
  prewarmUsersSettingsAvatarsFromCache,
} from "./utils/usersSettingsCache";

import "./index.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

/*
 * Prewarm cached settings images before React mounts.
 *
 * React does not wait for these promises, but the browser starts
 * downloading/decoding the cached images as early as possible.
 */
Promise.allSettled([
  prewarmCompanySettingsPhotoFromCache(),
  prewarmProfileSettingsAvatarFromCache(),
  prewarmUsersSettingsAvatarsFromCache(),
]);

// limpeza antiga de tema (ok manter)
try {
  localStorage.removeItem(
    "app.theme"
  );

  window.removeEventListener?.(
    "storage",
    () => {}
  );

  document.body?.removeAttribute(
    "data-theme"
  );

  document.documentElement?.classList.remove(
    "dark",
    "light",
    "theme-dark",
    "theme-light"
  );

  document.body?.classList.remove(
    "dark",
    "light",
    "theme-dark",
    "theme-light"
  );
} catch {}

const root =
  ReactDOM.createRoot(
    document.getElementById(
      "root"
    )
  );


const renderApplication =
  () => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );

    reportWebVitals();
  };


i18nReady
  .then(
    renderApplication
  )
  .catch(
    (
      error
    ) => {
      /*
       * i18nReady already handles initialization errors,
       * but keep the application boot resilient.
       */
      console.error(
        "[bootstrap] i18n readiness failed:",
        error
      );

      renderApplication();
    }
  );